import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createSlice } from '@reduxjs/toolkit'
import { fetchAsset } from './Actions'
import { AssetState } from './Type'

export const initialState: AssetState = {
  status: FetchStatus.IDLE,
  asset: undefined,
}

export const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsset.pending, (state) => {
        state.status = FetchStatus.LOADING
      })
      .addCase(fetchAsset.fulfilled, (state, action) => {
        state.status = FetchStatus.SUCCEEDED
        state.asset = action.payload
      })
      .addCase(fetchAsset.rejected, (state, action) => {
        if (action.payload?.code === 404) {
          state.status = FetchStatus.NOT_FOUND
        } else {
          state.status = FetchStatus.FAILED
        }
      })
  },
})
